import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-numselect',
  templateUrl: './numselect.component.html',
  styleUrls: ['./numselect.component.scss']
})
export class numselectComponent implements OnInit {
  @Input() model!: number;
  @Input() to!: number;
  @Input() name!: string;
  @Input() placeholder!: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() poss = false;
  @Input() myForm!: NgForm;
  @Output() modelChange = new EventEmitter<number>();

  numbers: any[];

  constructor() {
    this.numbers = new Array<number>();
  }

  ngOnInit(): void {
    this.numbers = Array(this.to).fill(5).map((x, i) => i + 1);
    this.numbers.unshift(0);
    if (this.poss) {
      this.numbers.push("Possibilità")
    }
  }

  // tslint:disable-next-line: typedef
  eventChange() {
    this.modelChange.emit(this.model);
  }

}
